export const headerStyles = {
  color: "rgba(47, 43, 61, 0.9)",
  fontSize: { sm: "1.5rem", xs: "1.3rem" },
  fontWeight: 600,
  lineHeight: "38px",
  textAlign: {
    xl: "left",
    lg: "left",
    md: "left",
    sm: "left",
    xs: "center",
  },
};

export const scrollContainerStyles = {
  flex: 1,
  flexBasis: 0,
  overflowY: "auto",
  marginRight: { xs: "-5px", md: "-15px" },
  paddingRight: { xs: "3px", md: "12px" },
};

export const mainContainerStyles = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
};

export const flexBoxStyles = {
  display: "flex",
  flexDirection: {
    xl: "row",
    lg: "row",
    md: "column",
    sm: "column",
    xs: "column",
  },
  alignItems: "flex-start",
  justifyContent: "space-between",
  width: "100%",
};

export const circularProgressStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  flexxGrow: 1,
  marginTop: "20px",
  position: "sticky",
  bottom: 0,
};

export const noCommunitiesTextStyles = {
  textAlign: "center",
};

export const gridItemStyles = {
  display: "flex",
  justifyContent: "center",
};

export const filterLoaderBoxStyles = {
  width: "100%",
  height: "calc(100dvh - 157px)",
  top: 0,
  bottom: 0,
  position: "absolute",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  zIndex: 99,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
